import React from "react";
import { CheckCircle } from "lucide-react";
import Automativecycle from "./automativecycle";
import Footer from "../../Home/Footer";
import WhatsAppServices from "../../Home/WhatsAppServices";
import Faqs from "../../Home/Faqs";
// Array for dynamic data
const travelLeadData = {
  heading: "Supercharge Your Automotive Business with WhatsApp Solutions",
  points: [
    "Promote your vehicles, services, and deals through powerful WhatsApp broadcasts.",
    "Offer round-the-clock customer support to handle inquiries at any time.",
    "Showcase your products, including cars and accessories, on a WhatsApp storefront.",
  ],
  buttons: [
    { text: "Try ChatMitra for Growth", className: "bg-[#075E54] text-white hover:bg-[#064d40]",buttonLink:"https://app.chatmitra.com/signin", },
    { text: "Request a Live Demo", className: "border border-[#075E54] text-[#075E54] hover:text-white" },
  ],
  image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Automotive_Business/Automotive_1.png",
};


const automotiveServices = [
  {
    id: 1,
    icon: <span className="text-2xl">🚗</span>, // Car icon
    title: "Boost Car Sales with WhatsApp for Dealerships",
    description: "Connect with potential buyers directly! Use WhatsApp to personalize chats about vehicle listings, pricing, and special deals. It’s like having a sales team in their pocket."
  },
  {
    id: 2,
    icon: <span className="text-2xl">🔧</span>, // Wrench icon
    title: "Simplify Auto Repairs with WhatsApp Support",
    description: "Make life easier for your customers. Schedule repairs, send friendly service reminders, and keep them updated via WhatsApp. It’s fast, convenient, and they’ll love the personal touch."
  },
  {
    id: 3,
    icon: <span className="text-2xl">📋</span>, // Checklist icon
    title: "Manage Fleets Seamlessly on WhatsApp",
    description: "Stay on top of your fleet with ease. Use WhatsApp to track vehicles, share maintenance reports, and coordinate with drivers—all in one place. It’s efficient and stress-free."
  },
  {
    id: 4,
    icon: <span className="text-2xl">💨</span>, // Speed icon
    title: "Engage Performance Enthusiasts via WhatsApp",
    description: "Wow your high-performance clients! Send exclusive upgrade alerts, consultation invites, and tips through WhatsApp to keep them coming back for more."
  },
  {
    id: 5,
    icon: <span className="text-2xl">📍</span>, // Location pin icon
    title: "Schedule Test Drives Easily with WhatsApp",
    description: "Let customers book test drives in a snap. Share vehicle details, confirm appointments, and follow up—all through WhatsApp. It’s the modern way to drive sales."
  },
  {
    id: 6,
    icon: <span className="text-2xl">🔋</span>, // Battery icon
    title: "Support Electric Vehicle Owners on WhatsApp",
    description: "Help EV owners thrive! Provide charging station info, maintenance tips, and real-time updates via WhatsApp. It’s the smart way to build loyalty."
  }
];

const automotiveFAQs = [
  {
    question: "How can WhatsApp grow my automotive business?",
    answer: "WhatsApp can boost your car sales and services by sending personalized vehicle listings and repair updates directly to customers. It’s like having a sales team that’s always on the road with you!"
  },
  {
    question: "Is WhatsApp secure for automotive transactions?",
    answer: "Yes, WhatsApp’s encryption keeps your vehicle details and client data safe. It’s like locking your inventory in a garage, so you can focus on driving sales without worry."
  },
  {
    question: "Can customers book car services on WhatsApp?",
    answer: "Absolutely! They can schedule repairs, oil changes, or test drives via WhatsApp. It’s like having a service bay that’s open 24/7, making maintenance a snap."
  },
  {
    question: "How does WhatsApp help sell cars?",
    answer: "Send stunning photos, pricing details, and special offers via WhatsApp to attract buyers. It’s like giving customers a test drive from their couch, closing deals faster."
  },
  {
    question: "What automotive content should I share on WhatsApp?",
    answer: "Share maintenance tips, new model launches, and fleet management updates via WhatsApp. It’s a direct line to keep your audience revved up and ready to buy or service."
  },
  {
    question: "Can WhatsApp manage fleet operations?",
    answer: "Yes! Coordinate maintenance, track vehicles, and share reports through WhatsApp. It’s like having a control center that keeps your fleet running smoothly, no matter where they are."
  },
  {
    question: "How do automotive customers feel about WhatsApp?",
    answer: "They love it! Customers appreciate the speed, convenience, and personal touch of WhatsApp. It’s less formal than calls and more immediate, making car care a breeze."
  },
  {
    question: "Can WhatsApp reduce my automotive workload?",
    answer: "Definitely! Automate responses to queries and handle bookings via WhatsApp, freeing your team for hands-on work. It’s like having an extra mechanic in the shop!"
  },
  {
    question: "How can I collect feedback on WhatsApp for my auto business?",
    answer: "Send surveys or ask for reviews on services and sales via WhatsApp. It’s a quick way to improve and show customers you value their input."
  },
  {
    question: "How do I set up WhatsApp for my automotive business?",
    answer: "Set up WhatsApp Business, create chat templates for sales and support, and use tools like ChatMitra. It’s a simple step to drive your business forward!"
  },
];

const Automative = () => {
  return (
    <>
      <section className="max-w-6xl mx-auto px-4 py-16 bg-white pt-28">
        <div className="flex flex-col lg:flex-row gap-12">
          <div className="w-full lg:w-1/2">
            <h1 className="text-4xl font-bold text-gray-800 mb-6">Supercharge Your Automotive Business with WhatsApp Solutions</h1>
            <ul className="space-y-4 text-gray-700">
              {travelLeadData.points.map((point, index) => (
                <li key={index} className="flex items-start gap-3">
                  <CheckCircle className="text-[#075E54] w-5 h-5 flex-shrink-0" />
                  <span>{point}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8 flex gap-4">
              {travelLeadData.buttons.map((button, index) => (
                <a
                key={index}
                href={button.buttonLink}
                className={`py-3 px-6 rounded-lg text-lg font-semibold ${button.className}`}
              >
                {button.text}
              </a>
              ))}
            </div>
          </div>
          <div className="w-full lg:w-1/2">
            <img src={travelLeadData.image} alt="Automotive Leads" className="w-full h-auto rounded-lg  hover:scale-105 transition-transform" />
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 py-8 text-center">
          <p className="text-lg text-gray-600">Grow your automotive business effortlessly and improve efficiency with WhatsApp. Start using the WhatsApp Business API with ChatMitra today.</p>
          <button className="mt-4 bg-[#075E54] text-white py-3 px-6 rounded-lg hover:bg-[#064d40] transition-colors">Get Start - No Credit Card Required</button>
        </div>
      </section>

      <Automativecycle />

      <WhatsAppServices servicesData={automotiveServices} isVisible={true}/>
      <Faqs faqs={automotiveFAQs} />
      <title>Grow Your Automotive Business with WhatsApp | ChatMitra</title>
      <meta name="description" content="Boost your automotive business with WhatsApp by promoting vehicles, scheduling test drives, automating service bookings, and engaging customers 24/7." />
      <meta name="keywords" content="WhatsApp for automotive, car sales WhatsApp, auto service booking, vehicle marketing, WhatsApp Business API, automotive customer support, ChatMitra" />
      <meta property="og:title" content="Grow Your Automotive Business with WhatsApp | ChatMitra" />
      <meta property="og:description" content="Learn how to use WhatsApp to showcase cars, schedule test drives, book services, and provide continuous support for your automotive business." />
      <meta property="og:url" content="https://blog.chatmitra.com/whatsapp-business-for-automotive-industry" />
      <meta property="og:type" content="website" />
      <Footer />
    </>
  );
};

export default Automative;
